module.exports = __webpack_public_path__ + "static/media/nd4.66ec1f50.webp";